export const activityLogsPageSize = 50;
export const activityLogsPageSizeForInMemorySearch = 50;
